export function confirmEmailErrorDetail(body) {
  if (!body || typeof body !== 'object') return '';
  const detail = body.detail || body.Detail;
  return typeof detail === 'string' ? detail : '';
}

export function isAlreadyConfirmedDetail(detail) {
  const text = String(detail || '').toLowerCase();
  return text.includes('уже подтвержден') || text.includes('already confirmed');
}

export function isConfirmEmailSuccess(status, body) {
  if (status >= 200 && status < 300) return true;
  if (status >= 300 && status < 400) return true;
  return isAlreadyConfirmedDetail(confirmEmailErrorDetail(body));
}
